export default {
  date: '日期',
  chooseExpDate: '選擇日期',
  filterExpDate: '依日期篩選',
  experienceType: '類型',
  filterExperienceType: '依類型篩選',
  experienceVibe: '氛圍',
  filterExperienceVibe: '依氛圍篩選',
  search: '搜尋',
  viewCalendar: '查看日曆',
  back: '返回',
  previous: '上一頁',
  next: '下一頁',
  noExperiences: '無體驗',
  cancelChanges: '取消變更',
  saveChanges: '儲存變更',
  removeFromReservation: '從預約中移除',
  addToCart: '加入購物車',
  proceedToCheckout: '前往結帳',
  selectDate: '選擇日期',
  startDate: '開始日期',
  endDate: '結束日期',
  submit: '提交',
  filterExperienceTypeScreenReader:
    '使用這些篩選器來縮小結果範圍。選擇篩選器時，內容會自動更新。',
};
